import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FONT_BODY, FONT_DISPLAY, TYPE, RADIUS } from '../../styles/recruiterTheme';

const NotificationDialog = ({ open, message, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: `${RADIUS.lg}px`, minWidth: 320 } }}>
      <DialogTitle
        sx={{
          fontFamily: FONT_DISPLAY,
          fontWeight: 700,
          fontSize: TYPE.section,
          lineHeight: 1.25,
          letterSpacing: '-0.02em',
          textAlign: 'center',
          p: '24px 24px 8px',
        }}
      >
        Notification
      </DialogTitle>
      <DialogContent sx={{ px: 3, pb: 1 }}>
        <Typography variant="body1" sx={{ fontFamily: FONT_BODY, fontSize: TYPE.body, lineHeight: 1.5, textAlign: 'center' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1.5 }} disableSpacing>
        <Button
          onClick={onClose}
          color="primary"
          sx={{ fontFamily: FONT_BODY, fontWeight: 600, textTransform: 'none', height: 36, px: 2, borderRadius: `${RADIUS.sm}px` }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDialog;
